import { render, staticRenderFns } from "./HotelDetails.vue?vue&type=template&id=a0f76986&scoped=true&"
import script from "./HotelDetails.vue?vue&type=script&lang=js&"
export * from "./HotelDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0f76986",
  null
  
)

export default component.exports